import React from "react";
import DashboardHeader from "./DashboardHeader";
import EmptyState from "./EmptyState";
import StudentsGrid from "./StudentsGrid";
import PaginationControls from "./PaginationControls";
import styles from "./ProfessorDashboard.module.css";

function MainContent({
  students,
  viewMode,
  onViewModeChange,
  totalPages,
  totalStudents,
  currentPage,
  pageSize,
  onPageChange,
  onStudentView,
  onToggleSave,
  onStudentContact,
}) {
  return (
    <div className={styles.mainContent}>
      <DashboardHeader
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        students={students}
        totalPages={totalPages}
        totalStudents={totalStudents}
        currentPage={currentPage}
        pageSize={pageSize}
      />

      {students.length === 0 ? (
        <EmptyState />
      ) : (
        <>
          <StudentsGrid
            students={students}
            viewMode={viewMode}
            onStudentView={onStudentView}
            onToggleSave={onToggleSave}
            onStudentContact={onStudentContact}
          />

          {totalPages > 1 && (
            <PaginationControls
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          )}
        </>
      )}
    </div>
  );
}

export default MainContent;
